import {FmlxModal} from 'fmlx-common-ui';
import {useMessageFooter} from '../../../hooks/useCustomFooter';
import {updateMessagePublish, updateMessageReject} from '../../../stores/business/messageInboxBusiness';

const MessageViewModal = ({open, onClose, succesButton, rejectButton, condition, onDataRefresh, selectedMessage}) => {
  const {renderFooterButtons} = useMessageFooter({
    buttons: [
      {
        label: 'REJECT',
        className: 'reject',
        variant: 'outline',
        type: 'danger',
        onClick: () => handleOnUpdateReject(selectedMessage),
      },
      {
        label: 'PUBLISH',
        className: 'publish',
        type: 'primary',
        onClick: () => handleOnUpdatePublish(selectedMessage),
      },
    ],
    conditionCheck: (path) => path.includes('/All'),
  });

  async function handleOnUpdatePublish(message) {
    const success = await updateMessagePublish(message);
    if (success) {
      onDataRefresh();
    }
  }

  async function handleOnUpdateReject(message) {
    const success = await updateMessageReject(message);
    if (success) {
      onDataRefresh();
    }
  }

  return (
    <FmlxModal
      open={open}
      size="md"
      title={'Message Detail'}
      onCloseClick={onClose}
      customFooter={condition ? renderFooterButtons() : <></>}
      primaryButton={succesButton}
      secondaryButton={rejectButton}
    >
      <div className="modal-content">
        {selectedMessage && (
          <div className="modal-content">
            <div style={{marginBottom: '16px'}}>
              <strong>Sender: </strong>
              {selectedMessage.sender}
              {selectedMessage.isAnonymous && ' (sent anonymously)'}
            </div>
            <div>
              <strong>Messages: </strong>
              <p>{selectedMessage.message}</p>
            </div>
          </div>
        )}
      </div>
    </FmlxModal>
  );
};

export default MessageViewModal;
